<template>
    <div class="v-crud-category-hierarchy-select">
        <el-select
            :value="parentID"
            @input="updateValue"
            placeholder="Please select a category"
            :loading="loading"
        >
            <el-option
                v-for="item in remoteValues"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    data() {
        return {
            remoteValues: [],
            loading: false,
            parentID: null,
            categoryID: null,
        };
    },
    name: 'v-crud-category-hierarchy-select',
    props: ['options', 'placeholder', 'value', 'rootConfig'],
    methods: {
        updateValue(v) {
            this.parentID = v;
            this.$emit('input', v);
        },
        getSortedCategories() {
            this.loading = true;
            this.api
                .get({ per_page: 1000 })
                .then((res) => {
                    if (res.data) {
                        this.remoteValues = res.data;
                        this.remoteValues = this.recursiveCategory(-1, [], 0);
                        const emptyOption = [
                            { id: 0, name: 'No parent (Top level)' },
                        ];
                        this.remoteValues = emptyOption.concat(
                            this.remoteValues
                        );
                        this.setCurrentParentID();
                        this.loading = false;
                    }
                })
                .catch((res) => {
                    this.loading = false;
                    console.error(res);
                    this.$message('Something went wrong. Please try again.');
                });
        },
        setCurrentParentID() {
            const currentCategory = this.remoteValues.find(
                (cat) => cat.id === this.$route.params.id
            );
            if (typeof currentCategory !== 'undefined') {
                this.parentID = currentCategory.parent_id;
            } else {
                this.updateValue(0);
            }
        },
        recursiveCategory(i, data, parentId) {
            const childData = this.remoteValues.filter(
                (e) => e.parent_id === parentId
            );
            if (childData) {
                i++;
                childData.forEach((e) => {
                    if (i > 0) {
                        let element = ['', '→', '»', '◦'];
                        e.name =
                            Array(4 * i)
                                .fill('\xa0')
                                .join('') +
                            (element[i] || '→') +
                            ' ' +
                            e.name;
                    }
                    data.push(e);
                    data = this.recursiveCategory(i, data, e.id);
                });
            }
            return data;
        },
    },
    mounted() {
        this.getSortedCategories();
    },
    computed: {
        api() {
            return this.$resource(
                [this.rootConfig.endPoint, 'categories', this.categoryID].join(
                    '/'
                ),
                {},
                {},
                { headers: this.rootConfig.headers }
            );
        },
    },
};
</script>

<style scoped>
.v-crud-category-hierarchy-select .el-select {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// CategoryHierarchySelect.vue?91243c3e